import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import { isNumber, toInteger, padNumber } from '@ng-bootstrap/ng-bootstrap/util/util';

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
    parse(value: string): NgbDateStruct {
        console.log(value);
        if (value) {
            const datePartsX = value.trim().split('T');
            const dateParts = datePartsX[0].trim().split('-');
            if (dateParts.length === 1 && isNumber(dateParts[0])) {
                return { day: toInteger(dateParts[2]), month: null, year: null };
            } else if (dateParts.length === 2 && isNumber(dateParts[2]) && isNumber(dateParts[1])) {
                return { day: toInteger(dateParts[0]), month: toInteger(dateParts[1]), year: null };
            } else if (dateParts.length === 3 && isNumber(dateParts[2]) && isNumber(dateParts[1]) && isNumber(dateParts[0])) {
                return { day: toInteger(dateParts[2]), month: toInteger(dateParts[1]), year: toInteger(dateParts[0]) };
            }
        }
        return null;
    }

    format(date: NgbDateStruct): string {
        //console.log(date);

        // return date ?
        //     ${isNumber(date.day) ? padNumber(date.day) : ''}-${isNumber(date.month) ? padNumber(date.month) : ''}-${date.year} :
        //     '';
        return date ?
            `${isNumber(date.day) ? padNumber(date.day) : ''}.${isNumber(date.month) ? padNumber(date.month) : ''}.${date.year} `: '';
    }
}